<template>
    <Head>
        <title>Organizations</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <navigation v-if="userId" :user-id="userId"/>
        </template>


        <div class="flex flex-col bg-white">

            <div class="p-4 flex flex-row justify-between">
                <form method="post" action="#" class="flex flex-row items-end gap-2" @submit.prevent="find">
                    <v-select label="KYC" v-model="filter.kyc" v-if="this.$page.props.auth.user.role !== 'aml'">
                        <option :value="null">Не использовать</option>
                        <option :value="false">Нет</option>
                        <option :value="true">Да</option>
                    </v-select>
                    <v-select label="Хост" v-model="filter.host" v-if="this.$page.props.auth.user.role !== 'aml'">
                        <option :value="null">Не использовать</option>
                        <option :value="host" v-for="host in hosts">{{ host }}</option>
                    </v-select>
                    <v-select label="Редактировалась" v-model="filter.edit" v-if="this.$page.props.auth.user.role !== 'aml'">
                        <option :value="null">Не использовать</option>
                        <option :value="false">Нет</option>
                        <option :value="true">Да</option>
                    </v-select>
                    <v-input lable="ID/Название" type="search" v-model="search" placeholder="Введите id или Название"/>
                    <v-button>Поиск</v-button>
                </form>
                <span
                    v-if="userId && access('organizations', 'create')"
                    @click="useForm({}).get(this.route('user.create-organizations', userId))"
                    class="flex items-center text-green-400 hover:text-green-600 cursor-pointer gap-2"
                >
                    <svg
                        class="fill-current h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                    >
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    ADD
                </span>
            </div>


            <div class="grid gap-6 p-2 items-end text-sm font-bold items-end" :class="`grid-cols-${userId ? 8 : 10}`">
                <div class="col-span-2">Название</div>
                <div v-if="!userId" class="col-span-2">Владелец</div>
                <div class="col-span-3 grid grid-cols-5 items-end gap-6">
                    <span>KYC</span>
                    <span>Rec</span>
                    <span>FP</span>
                    <span>Обмен</span>
                    <span>Трансфер</span>
                </div>
                <div>Группа</div>
                <div class="text-center">Создана (UTC)</div>
            </div>


            <div v-for="org in result" class="grid p-2 gap-6 items-center border-t" :class="`grid-cols-${userId ? 8 : 10}`">

                <div class="col-span-2 flex flex-row gap-2">
                    <svg
                        v-if="userId"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-current h-6 w-6"
                        :class="org.isOwner ? 'text-blue-600' : 'text-gray-200'"
                        viewBox="0 0 16 16">
                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                    </svg>
                    <div class="flex flex-col">
                        <span>{{ org.name }}</span>
                        <span class="text-sm">{{ org.internalName }}</span>
                    </div>
                </div>

                <div v-if="!userId" class="col-span-2 flex flex-col text-sm">
                    <Link v-for="owner in org.owners" :href="route('ocp.user', owner.id)" class="text-blue-700 hover:text-blue-900">
                        {{ owner.email }}
                    </Link>
                </div>

                <div class="col-span-3 grid grid-cols-5 items-center gap-6">
                    <svg
                        v-for="item in ['kycApprove', 'allowRecurrent', 'allowFreePayment', 'allowCrosschainSwaps', 'allowCrosschainTransfers']"
                        :class="org[item] ? 'text-green-400' : 'text-red-400'"
                        xmlns="http://www.w3.org/2000/svg"
                        class="fill-current h-6 w-6"
                        viewBox="0 0 16 16"
                    >
                        <path v-if="org[item]" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </div>

                <div class="text-xs">{{ org.exchangeGroup || 'Не используется' }}</div>

                <div class="text-center text-xs">{{ moment(org.createdAt).utc().format('L LTS') }}</div>


                <Link :href="route('organization', org.id)" class="text-blue-700 hover:text-blue-900">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </Link>

            </div>

            <v-pagination
                class="px-2 py-6"
                :count="total"
                :page="page"
                :limit="limit"
                :paginate="paginate"
            />


        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VPagination from '@/Components/PaginationOffset';
import moment from "moment";
import VButton from "@/Components/Button";
import VInput from "@/Components/Input";
import VSelect from "@/Components/Select";

export default {
    components: {
        VInput, VButton,
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VPagination,
        VSelect,
    },
    props: {
        limit: Number,
        page: Number,
        userId: String,
        success: Boolean,
        total: Number,
        result: Object,
        search: String,
        filter: Object,
        hosts: Array,
        notifications: Array,
    },
    methods: {
        useForm,
        moment,
        paginate(page) {
            const {userId, search, filter} = this;
            useForm({page, search, filter})
                .get(userId ? this.route('user.organizations', userId) : this.route('organizations'));
        },
        find() {
            const {userId, search, filter} = this;
            useForm({search, filter})
                .get(userId ? this.route('user.organizations', userId) : this.route('organizations'));
        }
    },
}
</script>
